import { defineNuxtPlugin } from '#imports'

import { unregisterBrazeServiceWorker } from '@backmarket/nuxt-module-tracking/unregisterBrazeServiceWorker'

/**
 * [LIF-2737] This function can be removed safely in January 2026.
 * Braze service worker has been removed. It now needs to be unregistered from user's browsers.
 */
export default defineNuxtPlugin(() => {
  unregisterBrazeServiceWorker()
})
